module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dynamic-pricing-expert-rule"
    }
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-pricing-expert"
  }, [_c('DragComponent', {
    attrs: {
      "name": _vm.name,
      "errors": _vm.errors,
      "formulaService": _vm.formulaService,
      "formulaAttributesService": _vm.formulaAttributesService,
      "formulaValueService": _vm.formulaValueService
    },
    on: {
      "getName": _vm.getName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticClass: "formulas"
  }, [_vm._v(_vm._s(_vm.serial))]), _vm._v(" "), _c('div', [_c('DropComponent', {
    attrs: {
      "input": _vm.input,
      "formulaService": _vm.formulaService
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.errors), function(error, index) {
    return (_vm.isNumber(index)) ? _c('div', {
      staticClass: "col-lg-12"
    }, [_c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.t(error)))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Submit')) + "\n                ")])])])], 1), _vm._v(" "), _c('DragComponent', {
    staticClass: "drag-component",
    attrs: {
      "name": _vm.name,
      "errors": _vm.errors,
      "formulaService": _vm.formulaService,
      "formulaAttributesService": _vm.formulaAttributesService,
      "formulaValueService": _vm.formulaValueService
    },
    on: {
      "getName": _vm.getName
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31c3757e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicPricingRuleExpertComponent.vue
// module id = 1263
// module chunks = 2